import { createFileRoute } from "@tanstack/react-router";
import Flags from "common/constants/flags";
import { StudioLiteGuard } from "lib/components/studioLite/StudioLiteGuard";
import { configureEditorStoreWithAPI } from "lib/studio/configureEditorStoreWithAPI";
import { DefaultEditorAPI } from "lib/studio/defaultEditorAPI";
import { useMemo } from "react";
import { Provider } from "react-redux";
import withAuthentication from "../../../components/withAuthentication";

function StudioLite() {
  const store = useMemo(
    () => configureEditorStoreWithAPI(DefaultEditorAPI, Flags.IS_DEV_MODE, { inspectorPanelExpanded: false }),
    [],
  );
  return (
    <Provider store={store}>
      <StudioLiteGuard />
    </Provider>
  );
}

export const Route = createFileRoute("/builders/$builder_id/guided-flow")({
  component: withAuthentication(StudioLite, {
    permissions: ["VIEW_STUDIO_FILES"],
    products: ["studio"],
    features: ["estimationTasks"],
  }),
});
